import { Modal, Form, Select } from 'antd';
import { authFetch } from '../../../../../common/request/authFetch';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { useFetch } from '../../../../../hooks/useFetch/useFetch';
import { useState } from 'react';
import { PREDEFINED_REPORTS } from '../../../menuUsers/reports/ReportTypes';
import { DrawerPanelTitle, modalPanelStyles } from '../../../common/Drawers/DrawerPanelTitle';

export const EditLocationReportConfigModal = (props: { 
    locationReportConfig: any, 
    scheduledReportList: any, 
    onFinish: any 
}) => {
    
    const [form] = Form.useForm();
    const { t } = useTranslation();    
    const { projectGroup } = useAuth();     
    const [reportOptions, setReportOptions] = useState();       
    const idsList = props.scheduledReportList?.map((report: any) => report.id) || [];
    useFetch(
        `${process.env.REACT_APP_API}/projects/${projectGroup.project}/scheduledReports?scope=LOCATION` ,
        {},
        [],
        (data) => {            
            setReportOptions(data.map((report: any) => ({
                value: report.id,
                label: PREDEFINED_REPORTS[report.type].name
            })) || []);
        }
    );

    const onFormFinish = async (values: any) => {
        // 'values.scheduledReports' contendrá un array con los IDs seleccionados
        await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/reports/${props.locationReportConfig.groupAccount}/${props.locationReportConfig.locationId}/scheduled`, { 
            method: 'PUT', 
            data: values 
        });        
        props.onFinish();
    };

    return (
        <Modal 
            open={true} 
            onOk={() => form.submit()} 
            onCancel={props.onFinish} 
            afterClose={form.resetFields}
            {...modalPanelStyles}
            okText='Guardar'
            cancelText='Cancelar'
            destroyOnClose
            title={<DrawerPanelTitle title="Asignar Informes" />}
        >
            <Form 
                layout='vertical' 
                form={form} 
                onFinish={onFormFinish}
                autoComplete="off"                
                initialValues={{ 
                    scheduledReports: idsList 
                }} 
            >                
                <Form.Item 
                    label='Informes' 
                    name='scheduledReports'                    
                >
                    <Select 
                        mode="multiple" 
                        style={{ width: '100%' }} 
                        placeholder="Selecciona los informes"
                        options={reportOptions} 
                        optionFilterProp="label" 
                    />
                </Form.Item>    
            </Form>
        </Modal>
    );
}